import {FlagValueString} from '../types';

export interface ABTestGroup {
  key: string;
  group: FlagValueString;
}

export type ABTests = ABTestGroup[];

export enum AB_TEST_COOKIES {
  UserId = 'ay-ab-test-user-id',
  Experiments = 'ay-active-ab-tests',
}

export enum AB_TEST_HEADERS {
  AYActiveABTests = 'X-AY-Active-AB-Tests',
  TadaridaConsideredABTests = 'x-tadarida-considered-ab-tests',
  TadaridaPossibleABTests = 'x-tadarida-possible-ab-tests',
}
